import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initCareerCenterSlider = () => {
  const sliderContainer = document.querySelector("[data-career-center-slider]");

  sliderContainer && new Swiper(sliderContainer, {
    lazy: true,
    breakpoints: {     
      768: {
        spaceBetween: 16,
        slidesPerView: 1.3,
      },       
      0: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: "[data-career-center-slider-container] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
    },
    navigation: {
      nextEl: "[data-career-center-slider-container] .slider-navigation__button--next",
      prevEl: "[data-career-center-slider-container] .slider-navigation__button--prev",
    },
  });
}


export default initCareerCenterSlider;
